import React from "react";
import styles from "./index.module.css";

import animation from "./animation.json";

import isBrowserEnv from "../../utils/isBrowserEnv";

let lottie;
let options;
const isBrowser = isBrowserEnv();

// Do some work up front to minimise the workload when mounting the component
// Might make the animation + page transition a bit smoother?
if (isBrowser) {
  lottie = require("lottie-web/build/player/lottie");
  options = {
    animationData: animation,
    loop: false,
    renderer: "svg"
  };
}

/**
 * Slim wrapper around the lottie lib. Based on react-bodymovin.
 */
class ChapterAnimation extends React.Component {
  componentDidMount() {
    if (!isBrowser) return;
    options.wrapper = this.wrapper;
    this.animation = lottie.loadAnimation(options);
  }

  componentWillUnmount() {
    if (!isBrowser) return;
    this.animation.destroy();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const storeWrapper = el => {
      this.wrapper = el;
    };

    return (
      <div className={styles.root} ref={storeWrapper}>
        {this.props.children}
      </div>
    );
  }
}

export default ChapterAnimation;



// WEBPACK FOOTER //
// ./src/components/ChapterAnimation/index.js